// extracted by mini-css-extract-plugin
export default {"drawingBoard":"drawingBoard_drawingBoard__vP577"};